import crud from './helpers/crud';

const getAutoUploadRules = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_AUTO_UPLOAD_RULES',
      fail: 'FAILED_GET_AUTO_UPLOAD_RULES',
      end: 'FINISH_GET_AUTO_UPLOAD_RULES',
    },
    method: 'GET',
    url: '/api/v1/auto_upload_rules',
  })
);

const createAutoUploadRule = (ruleObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_CREATE_AUTO_UPLOAD_RULE',
      fail: 'FAILED_CREATE_AUTO_UPLOAD_RULE',
      end: 'FINISH_CREATE_AUTO_UPLOAD_RULE',
    },
    method: 'POST',
    data: { auto_upload_rule: ruleObject },
    url: '/api/v1/auto_upload_rules',
  })
);

const updateAutoUploadRule = (id, ruleObject) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_AUTO_UPLOAD_RULE',
      fail: 'FAILED_UPDATE_AUTO_UPLOAD_RULE',
      end: 'FINISH_UPDATE_AUTO_UPLOAD_RULE',
    },
    method: 'PUT',
    url: `/api/v1/auto_upload_rules/${id}`,
    data: { auto_upload_rule: ruleObject },
  })
);

const deleteAutoUploadRule = (id) => (
  crud({
    dispatch: {
      begin: 'BEGIN_DELETE_AUTO_UPLOAD_RULE',
      fail: 'FAILED_DELETE_AUTO_UPLOAD_RULE',
      end: 'FINISH_DELETE_AUTO_UPLOAD_RULE',
    },
    method: 'DELETE',
    url: `/api/v1/auto_upload_rules/${id}`,
  })
);

// Explicit "import previous settings / reset" — replaces the org's rules with a
// fresh import of its legacy config.
const importAutoUploadRules = () => (
  crud({
    dispatch: {
      begin: 'BEGIN_IMPORT_AUTO_UPLOAD_RULES',
      fail: 'FAILED_IMPORT_AUTO_UPLOAD_RULES',
      end: 'FINISH_IMPORT_AUTO_UPLOAD_RULES',
    },
    method: 'POST',
    url: '/api/v1/auto_upload_rules/import',
  })
);

// Persist a new top-to-bottom rule ordering. The endpoint returns the full,
// re-ordered rule list which the reducer swaps in.
const reorderAutoUploadRules = (ruleIds) => (
  crud({
    dispatch: {
      begin: 'BEGIN_REORDER_AUTO_UPLOAD_RULES',
      fail: 'FAILED_REORDER_AUTO_UPLOAD_RULES',
      end: 'FINISH_REORDER_AUTO_UPLOAD_RULES',
    },
    method: 'POST',
    url: '/api/v1/auto_upload_rules/reorder',
    data: { rule_ids: ruleIds },
  })
);

// Dry-run the current rules against recent documents for the "Test rules" preview.
const previewAutoUploadRules = (limit = 10) => (
  crud({
    dispatch: {
      begin: 'BEGIN_PREVIEW_AUTO_UPLOAD_RULES',
      fail: 'FAILED_PREVIEW_AUTO_UPLOAD_RULES',
      end: 'FINISH_PREVIEW_AUTO_UPLOAD_RULES',
    },
    method: 'GET',
    url: '/api/v1/auto_upload_rules/match_preview',
    params: { limit },
  })
);

export {
  getAutoUploadRules,
  createAutoUploadRule,
  updateAutoUploadRule,
  deleteAutoUploadRule,
  importAutoUploadRules,
  reorderAutoUploadRules,
  previewAutoUploadRules,
};
